import { Page } from '@/core/architecture'

import { Forbidden } from '../Errors/Forbidden'
import { LotteryConfirmationTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * LotteryConfirmation Page
 * Implemented as a practical sample.
 */
export const LotteryConfirmation: Page = () => {
  const { state, actions } = useViewModel()

  if (state.isRootAuthFailed) {
    return <Forbidden useNextRouter={false} />
  }

  return <LotteryConfirmationTemplate state={state} {...actions} />
}
